import { render, staticRenderFns } from "./WizardFooter.vue?vue&type=template&id=4215014f&scoped=true&lang=html&"
import script from "./WizardFooter.vue?vue&type=script&lang=js&"
export * from "./WizardFooter.vue?vue&type=script&lang=js&"
import style0 from "./WizardFooter.vue?vue&type=style&index=0&id=4215014f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4215014f",
  null
  
)

export default component.exports